import localStorageEx from 'bundles/common/utils/localStorageEx';

function stringToBoolean(value: string) {
  if (value === 'true') {
    return true;
  } else if (value === 'false') {
    return false;
  }
  return undefined;
}

function sanitizeState({ expanded, toolSelected }: { expanded: string; toolSelected: string | null }) {
  const expandedResult = stringToBoolean(expanded);

  if (expandedResult === undefined) {
    return undefined;
  }
  return { expanded: expandedResult, toolSelected };
}

export function courseToolBarLocalStorageHandler() {
  const expanded = false;
  const toolSelected: null | string = null;

  function getState() {
    return localStorageEx.getItem(
      'courseToolBarState',
      (value) => {
        if (value) {
          const [expandedValue, toolSelectedValue] = value.split(',');

          return sanitizeState({ expanded: expandedValue, toolSelected: toolSelectedValue });
        }
        return undefined;
      },
      { expanded, toolSelected }
    );
  }

  function setState(stateProps: { expanded: boolean; toolSelected: string | null }) {
    localStorageEx.setItem('courseToolBarState', stateProps, (values) => `${values.expanded},${values.toolSelected}`);
  }
  return {
    getState,
    setState,
  };
}
